<template>
  <div class="order-print-management">
    <!-- 搜索栏 -->
    <div class="search-container">
      <a-input
        placeholder="搜索指定波次订单/货车"
        style="width: 300px"
      />
      <a-icon type="sync" class="refresh-icon" />
    </div>

    <!-- 操作区 -->
    <div class="operation-bar">
      <!-- 左侧部分：打印选项 -->
      <div class="left-section">
        <a-dropdown>
          <a-button type="primary" class="print-button">
            <a-icon type="printer" />
            打印
            <a-icon type="down" />
          </a-button>
        </a-dropdown>

        <a-checkbox-group class="print-checkboxes">
          <a-checkbox>快递单</a-checkbox>
          <a-checkbox>发货单</a-checkbox>
          <a-checkbox>汇总单</a-checkbox>
          <a-checkbox>分配任务栏</a-checkbox>
          <a-checkbox>指定模板</a-checkbox>
          <a-checkbox>赠品汇总单</a-checkbox>
        </a-checkbox-group>
      </div>

      <!-- 右侧部分：确认按钮和波次进度 -->
      <div class="right-section">
        <div class="confirm-section">
          <a-button type="primary" class="confirm-button">确认</a-button>

          <a-checkbox-group class="confirm-checkboxes">
            <a-checkbox>快递单</a-checkbox>
            <a-checkbox>取消提示</a-checkbox>
          </a-checkbox-group>
        </div>

        <div class="wave-progress">
          波次进度
          <span class="progress-value" >0/0</span>
          <a-icon type="setting" class="setting-icon" />
        </div>
      </div>
    </div>

    <!-- 主要内容区 - 两个表格 -->
    <div class="tables-container">
      <!-- 未打印单据表格 -->
      <div class="table-wrapper">
        <div class="table-header">
          <span class="table-title">未打印单据</span>

          <div class="table-filters">
            <a-select placeholder="选择波次特征" class="filter-select">
              <a-select-option value="">选择波次特征</a-select-option>
            </a-select>

            <a-select placeholder="选择承运商" class="filter-select">
              <a-select-option value="">选择承运商</a-select-option>
            </a-select>

            <a-select placeholder="选择库区" class="filter-select">
              <a-select-option value="">选择库区</a-select-option>
            </a-select>
          </div>
        </div>

        <a-table
          :columns="unprintedColumns"
          :data-source="emptyData"
          :pagination="paginationConfig"
          rowKey="id"
          bordered
          class="content-table"
        >
          <template slot="emptyText">
            <div style="height: 300px;"></div>
          </template>
        </a-table>
      </div>

      <!-- 已打印单据表格 -->
      <div class="table-wrapper">
        <div class="table-header">
          <span class="table-title">已打印单据</span>
          <!-- 空的筛选容器，用于保持高度一致 -->
          <div class="table-filters placeholder-filters"></div>
        </div>

        <a-table
          :columns="printedColumns"
          :data-source="emptyData"
          :pagination="paginationConfig"
          rowKey="id"
          bordered
          class="content-table"
        >
          <template slot="emptyText">
            <div style="height: 300px; position: relative;">
              <div class="print-status-indicator">
                <a-avatar icon="printer" shape="circle" />
              </div>
            </div>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 未打印单据表格列配置 - 统一设置宽度确保对齐
      unprintedColumns: [
        {
          title: '',
          dataIndex: 'checkbox',
          width: 40,
          render: () => <a-checkbox />
        },
        {
          title: '货主',
          dataIndex: 'owner',
          key: 'owner',
          width: 100
        },
        {
          title: '波次计划',
          dataIndex: 'wavePlan',
          key: 'wavePlan',
          width: 120
        },
        {
          title: '波次特征',
          dataIndex: 'waveFeature',
          key: 'waveFeature',
          width: 100
        },
        {
          title: '承运商',
          dataIndex: 'carrier',
          key: 'carrier',
          width: 100
        },
        {
          title: 'SKU种类数',
          dataIndex: 'skuTypeCount',
          key: 'skuTypeCount',
          width: 90
        },
        {
          title: '单量',
          dataIndex: 'orderCount',
          key: 'orderCount',
          width: 70
        },
        {
          title: '有效订单',
          dataIndex: 'validOrder',
          key: 'validOrder',
          width: 90
        },
        {
          title: '打印状态',
          dataIndex: 'printStatus',
          key: 'printStatus',
          width: 100
        },
      ],

      // 已打印单据表格列配置 - 统一设置宽度确保对齐
      printedColumns: [
        {
          title: '',
          dataIndex: 'checkbox',
          width: 40,
          render: () => <a-checkbox />
        },
        {
          title: '货主',
          dataIndex: 'owner',
          key: 'owner',
          width: 100
        },
        {
          title: '打印人',
          dataIndex: 'printer',
          key: 'printer',
          width: 100
        },
        {
          title: '波次计划',
          dataIndex: 'wavePlan',
          key: 'wavePlan',
          width: 120
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          width: 150
        },
        {
          title: '单量',
          dataIndex: 'orderCount',
          key: 'orderCount',
          width: 70
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          width: 100
        },
      ],

      // 空数据
      emptyData: [],

      // 分页配置
      paginationConfig: {
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total) => `显示0到0,共0记录`,
        current: 1,
        total: 0
      }
    };
  }
};
</script>

<style scoped>
.order-print-management {
  padding: 16px;
  background-color: #fff;
  min-height: 100vh;
  box-sizing: border-box;
  max-width: 100%;
  overflow-x: hidden;
}

.search-container {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.refresh-icon {
  font-size: 16px;
  cursor: pointer;
  color: #888;
}

.operation-bar {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
}

.left-section, .right-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.print-button {
  white-space: nowrap;
}

.print-checkboxes {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.confirm-section {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.confirm-button {
  min-width: 80px;
  white-space: nowrap;
}

.wave-progress {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  white-space: nowrap;
}

.progress-value {
  font-size: 43px;
  font-weight: bold;
  color: #00b42a;
}

.setting-icon {
  color: #888;
  cursor: pointer;
}

/* 表格容器使用网格布局确保平分宽度 */
.tables-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
}

.table-wrapper {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

/* 统一表格头部高度 */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  min-height: 40px; /* 固定最小高度 */
  padding: 4px 0; /* 统一内边距 */
}

.table-title {
  font-weight: bold;
  font-size: 14px;
  display: flex;
  align-items: center;
  height: 100%;
}

.table-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: calc(100% - 80px); /* 限制最大宽度，防止溢出 */
  align-items: center;
  height: 100%;
}

/* 右侧表格的空筛选容器，保持高度一致 */
.placeholder-filters {
  visibility: hidden; /* 隐藏但保留空间 */
}

/* 筛选选择器样式 */
.filter-select {
  width: 120px !important;
  max-width: 30%; /* 确保不会超出容器 */
  box-sizing: border-box;
}

.print-status-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

/* 表格样式优化 */
.content-table {
  width: 100%;
  box-sizing: border-box;
  table-layout: fixed; /* 固定表格布局，确保列宽一致 */
}

/* 解决表格空状态高度问题 */
/deep/ .ant-table-body {
  min-height: 300px;
  overflow-x: auto; /* 表格内容过宽时显示水平滚动条 */
}

/* 统一表格单元格样式，确保对齐 */
/deep/ .ant-table td,
/deep/ .ant-table th {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .operation-bar, .tables-container {
    grid-template-columns: 1fr;
  }

  .filter-select {
    width: 100px !important;
  }
}

@media (max-width: 768px) {
  .left-section, .right-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .print-checkboxes, .confirm-checkboxes {
    gap: 10px;
  }

  .table-filters {
    max-width: 100%;
  }

  .filter-select {
    width: 45% !important;
    max-width: none;
  }
}
</style>
